const Line = ({ l, i }) => {
  if (l.startsWith("## ")) return <h2 key={i} className="pt-4 text-lg font-extrabold">{l.slice(3)}</h2>;
  if (l.startsWith("- ")) return <li key={i} className="ml-5 list-disc">{l.slice(2)}</li>;
  return <p key={i}>{l}</p>;
};

export const LegalText = ({ content }) => (
  <div className="space-y-2 text-sm leading-relaxed text-muted-foreground sm:text-base [&_h2]:text-foreground" data-testid="legal-content">
    {content.split("\n").filter((l) => l.trim()).map((l, i) => <Line key={i} l={l} i={i} />)}
  </div>
);
